module.exports = __webpack_public_path__ + "static/media/monument.c649df75.svg";